"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const useStyles = (0, styles_1.makeStyles)((theme) => ({
    superBonus: {
        display: 'flex',
        borderRadius: 10,
        backgroundColor: theme.palette.text.secondary.lighten(0.83).getWithAlpha(0.083),
        border: `2px solid ${theme.palette.secondary.main}`,
        alignItems: 'center',
        padding: theme.spacing(2),
        marginTop: theme.spacing(3),
        cursor: 'pointer',
        marginBottom: theme.spacing(3),
        [theme.breakpoints.down('sm')]: {
            padding: 0
        }
    },
    star: {
        width: 59,
        height: 61
    },
    superBonusProgress: {
        [theme.breakpoints.down('sm')]: {
            paddingLeft: theme.spacing(2)
        }
    },
    superBonusProgressText: {
        [theme.breakpoints.down('sm')]: Object.assign({}, theme.typography.body2)
    }
}));
exports.default = useStyles;
//# sourceMappingURL=SuperBonusTagStyle.js.map